export default __webpack_public_path__ + "static/media/fortnite.56ffc372.png";